export default "__VITE_ASSET__DDx19t7c__"